/**
 * Sound Service Type Definitions
 * @module services/sound/types
 */

/**
 * Sound types that can be played
 */
export type SoundType =
  | 'attack'
  | 'hit'
  | 'projectileLaunch'
  | 'projectileImpact'
  | 'spawn'
  | 'death';

/**
 * Creature-specific sound types (generated per creature)
 */
export type CreatureSoundType = 'attack' | 'hit' | 'projectileLaunch' | 'projectileImpact';

/**
 * Shared sound types (same for all creatures)
 */
export type SharedSoundType = 'spawn' | 'death' | 'defaultAttack' | 'defaultHit';

/**
 * Sound URLs for a creature (matches CreatureDocument.sounds)
 */
export interface CreatureSoundUrls {
  attack?: string;
  hit?: string;
  projectileLaunch?: string;
  projectileImpact?: string;
}

/**
 * Sound Manager configuration
 */
export interface SoundManagerConfig {
  /** Master volume 0.0 - 1.0 */
  masterVolume: number;
  /** Effects volume multiplier 0.0 - 1.0 */
  effectsVolume: number;
  /** Maximum concurrent sounds before ducking */
  maxConcurrentSounds: number;
  /** Volume reduction factor when ducking (0.0 - 1.0) */
  duckingFactor: number;
}

/**
 * Default configuration
 */
export const DEFAULT_SOUND_CONFIG: SoundManagerConfig = {
  masterVolume: 0.8,
  effectsVolume: 1.0,
  maxConcurrentSounds: 8,
  duckingFactor: 0.7,
};
